import { reflect } from '@effector/reflect';
import { Select } from '@mantine/core';
import { useUnit } from 'effector-react';
import { createEditGameSettingModal } from 'features/edit-game-setting';
import { createResetGameSettingModal } from 'features/reset-game-setting';
import { createGameSettingRegistry } from 'entities/game-setting';
import { translated } from 'shared/lib';
import { accountPageGameSettingsModel } from '../../model';
import cls from './account-page-game-settings.module.scss';

const GameSettingsRegistry = createGameSettingRegistry(
	accountPageGameSettingsModel.gameSettingRegistryModel,
);

const EditGameSettingModal = createEditGameSettingModal(
	accountPageGameSettingsModel.editGameSettingModel,
);

const ResetGameSettingModal = createResetGameSettingModal(
	accountPageGameSettingsModel.resetGameSettingModel,
);

const GameFilter = reflect({
	view: Select,
	bind: {
		'data-test-id': 'account-page-game-settings-game-filter',
		value: accountPageGameSettingsModel.$gameId.map((id) => `${id}`),
		data: accountPageGameSettingsModel.$games,
		label: translated('account-page.game'),
		searchable: true,
		clearable: false,
	},
});

export const AccountPageGameSettings = () => {
	const game = useUnit(accountPageGameSettingsModel.$game);

	return (
		<>
			<GameSettingsRegistry
				withTitle={false}
				withAccount={false}
				className={cls.accountPageGameSettingsRegistry}
				filterSlot={<GameFilter />}
				tableTdActionSlot={(setting) =>
					game !== null && (
						<div className={cls.accountPageGameSettingsActions}>
							<EditGameSettingModal.ActionIcon modalData={{ ...setting, game }} />
							<ResetGameSettingModal.ActionIcon modalData={{ ...setting, game }} />
						</div>
					)
				}
			/>
			<EditGameSettingModal />
			<ResetGameSettingModal />
		</>
	);
};
